import type { Step } from "react-joyride";

export const contractDetailTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຍິນດີຕ້ອນຮັບສູ່ຫນ້າລາຍລະອຽດສັນຍາ! ຫນ້ານີ້ຈະສະແດງຂໍ້ມູນທັງໝົດຂອງສັນຍາ. ທ່ານຈະໄດ້ຮຽນຮູ້ວິທີໃຊ້ງານຫນ້ານີ້ໃນບົດສອນສັ້ນໆນີ້.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="detail-header"]',
    content:
      "ນີ້ແມ່ນສ່ວນ header. ທ່ານສາມາດກັບໄປຫນ້າລາຍການສັນຍາດ້ວຍປຸ່ມ 'ກັບ', ສົ່ງອອກ PDF ດ້ວຍປຸ່ມ 'ສົ່ງອອກ', ແກ້ໄຂສັນຍານີ້ດ້ວຍປຸ່ມ 'ແກ້ໄຂ', ຕໍ່ອາຍຸດ້ວຍປຸ່ມ 'ຕໍ່ອາຍຸ', ຫຼືລຶບສັນຍາດ້ວຍປຸ່ມລຶບ (ຖ້າທ່ານມີສິດ).",
    placement: "bottom",
  },
  {
    target: '[data-tourid="detail-basic-info"]',
    content:
      "ນີ້ແມ່ນຂໍ້ມູນທົ່ວໄປຂອງສັນຍາ. ທ່ານຈະເຫັນເລກທີສັນຍາ, ປະເພດສັນຍາ, ຄູ່ສັນຍາ, ແລະຂໍ້ມູນຕິດຕໍ່ຄູ່ສັນຍາ.",
    placement: "top",
  },
  {
    target: '[data-tourid="detail-schedule"]',
    content:
      "ນີ້ແມ່ນພາກສ່ວນໄລຍະເວລາ & ເງື່ອນໄຂ. ທ່ານຈະເຫັນວັນທີເລີ່ມ, ວັນທີຫມົດອາຍຸ, ໄລຍະເວລາ, ການຕໍ່ອາຍຸອັດຕະໂນມັດ, ແລະໄລຍະເວລາແຈ້ງເຕືອນ.",
    placement: "top",
  },
  {
    target: '[data-tourid="detail-administration"]',
    content:
      "ນີ້ແມ່ນພາກສ່ວນການບໍລິຫານ. ທ່ານຈະເຫັນຜູ້ຮັບຜິດຊອບ, ພະແນກ, ແລະສຸຂະພາບສັນຍາ (ສະແດງເປັນເປີເຊັນ).",
    placement: "top",
  },
  {
    target: '[data-tourid="detail-documents"]',
    content:
      "ນີ້ແມ່ນພາກສ່ວນເອກະສານ. ທ່ານຈະເຫັນເອກະສານຫຼັກ, ເອກະສານແນບສະໜັບສະໜູນ, ແລະປະຫວັດເວີຊັນໄຟລ໌. ທ່ານສາມາດເບິ່ງ ຫຼື ດາວໂຫຼດເອກະສານໄດ້.",
    placement: "top",
  },
  {
    target: '[data-tourid="detail-notes"]',
    content:
      "ນີ້ແມ່ນພາກສ່ວນໝາຍເຫດ, ຂໍ້ຄວນລະວັງ, ແລະເງື່ອນໄຂພິເສດ (ຖ້າມີ). ທ່ານຈະເຫັນຂໍ້ມູນເພີ່ມເຕີມກ່ຽວກັບສັນຍານີ້.",
    placement: "top",
  },
  {
    target: '[data-tourid="detail-renewals"]',
    content:
      "ນີ້ແມ່ນພາກສ່ວນວົງຈອນຊີວິດສັນຍາ & ຜະແນການຕໍ່ອາຍຸ (ຖ້າມີ). ທ່ານຈະເຫັນປະຫວັດການຕໍ່ອາຍຸ ແລະ ໄລຍະເວລາປັດຈຸບັນຂອງສັນຍາ.",
    placement: "top",
  },
];
